/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PaymentType {
    None = 0,
    Cash = 1,
    Card = 2,
    Check = 4,
    CreditCard = 8,
    DebitCard = 16,
}
